import { useEffect, useState } from "react";
import { getWaApp, setWaApp } from "@/lib/api";
import { MessageCircle, Briefcase } from "lucide-react";

export function WaAppToggle({ className = "" }) {
  const [app, setApp] = useState(getWaApp());
  useEffect(() => { const h = () => setApp(getWaApp()); window.addEventListener("wa-app-changed", h); return () => window.removeEventListener("wa-app-changed", h); }, []);
  const isAndroid = /android/i.test(navigator.userAgent);
  return (
    <div className={`mt-2 inline-flex flex-col gap-1 ${className}`} data-testid="wa-app-toggle">
      <div className="inline-flex rounded-full border bg-card p-0.5 text-xs">
        {[["whatsapp", "WhatsApp", MessageCircle], ["business", "WhatsApp Business", Briefcase]].map(([k, l, Icon]) => (
          <button key={k} type="button" onClick={() => setWaApp(k)} className={`inline-flex items-center gap-1 px-3 py-1 rounded-full transition-colors ${app === k ? "bg-[#25D366] text-white" : "hover:bg-muted"}`} data-testid={`wa-app-${k}`}><Icon className="h-3.5 w-3.5" /> {l}</button>
        ))}
      </div>
      <p className="text-[11px] text-muted-foreground">Open chats in {app === "business" ? "WhatsApp Business" : "regular WhatsApp"} on this device.{app === "business" && !isAndroid ? " On iPhone/desktop the system picks the app — set WhatsApp Business as default in Settings." : ""}</p>
    </div>
  );
}
